const data = {
  ErrorModule: 0,
  ErrorCode: 0,
  CascadingErrorInfo: "ok",
  Data: {
    Material: {
      id: 1,
      materialName: {
        "@max": 64,
      },
      materialRemarks: {
        "@max": 64,
      },
      materialType: {
        "@opt": "static,dynamic",
      },
      approveState: {
        "@opt": "approved,notPass,notApprove",
      },
      collectProperty: {
        "@opt": "not collected,collected",
      },
      approveRemarks: {
        "@max": 128,
      },
      shareProperty: {
        "@opt": "public,private",
      },
      uploadUser: {
        "@max": 32,
      },
      uploadTime: "",
      orgNo: 1,
      replaceTerminal: {
        "@opt": "true,false",
      },
      StaticMaterial: {
        staticMaterialType: {
          "@opt":
            "picture,audio,video,document,template,clock,pdf,web,app,doc,excel,ppt,zip,font",
        },
        picFormat: {
          "@opt": "bmp,gif,jpg,png,jpeg",
        },
        flashFormat: {
          "@opt": "swf",
        },
        picResolution: {
          width: {
            "@min": 120,
            "@max": 3840,
          },
          height: {
            "@min": 120,
            "@max": 3840,
          },
        },
        audioFormat: {
          "@opt": "mp3,wav,wma",
        },
        videoFormat: {
          "@opt": "asf,avi,mpg,3gp,mov,mkv,wmv,flv,mp4",
        },
        pdfFormat: {
          "@opt": "pdf",
        },
        webFormat: {
          "@opt": "html,htm",
        },
        appFormat: {
          "@opt": "apk",
        },
        pptFormat: {
          "@opt": "ppt,pptx",
        },
        docFormat: {
          "@opt": "doc,docx",
        },
        excelFormat: {
          "@opt": "xls,xlsx",
        },
        fontFormat: {
          "@opt": "ttf,otf",
        },
      },
      DynamicMaterial: {
        dynamicMaterialType: {
          "@opt": "web,realStream,generalData,picUrl",
        },
        webUrl: {
          "@min": 1,
          "@max": 256,
        },
        rssUrl: {
          "@min": 1,
          "@max": 256,
        },
        picUrl: {
          "@min": 1,
          "@max": 256,
        },
        RealStream: {
          destionType: {
            "@opt": "streamMedia,normalIPC",
          },
          streamMediaUrl: {
            "@min": 1,
            "@max": 256,
          },
          NormalIPC: {
            IpAddress: {
              ipVersion: {
                "@opt": "v4",
              },
              ipAddress: "",
              ipv6Address: "",
            },
            portNo: {
              "@min": 1,
              "@max": 65535,
            },
            channelNo: {
              "@min": 0,
              "@max": 256,
            },
            userName: {
              "@min": 1,
              "@max": 32,
            },
            passWord: {
              "@min": 1,
              "@max": 32,
            },
            transmitProtocol: {
              "@opt": "tcp,udp,mcast",
            },
            streamType: {
              "@opt": "main,sub,third",
            },
          },
          dataType: {
            "@opt": "liveVideo",
          },
        },
      },
    },
  },
};
export default data;
